var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ [_vm.styles.field]: true, [_vm.styles.error]: _vm.error }},[(_vm.label != null)?_c('label',{class:{ [_vm.styles.not_required]: !_vm.required }},[_vm._v(_vm._s(_vm.label)+" "),(_vm.required)?_c('span',[_vm._v("*")]):_vm._e()]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }